import { CustomerAccountSelectedEquipmentImageProps } from '../../types';

export const CustomerAccountSelectedEquipmentImage = ({
  imgSrc,
  imgAlt
}: CustomerAccountSelectedEquipmentImageProps) => {
  return <img src={imgSrc} alt={imgAlt} loading="lazy" />;
};
